import {FILTER_NAMES} from '../base.js'
import {QUERY_PARAMS} from '../common/queryParams.js'

export const HIGHLIGHT_TYPES = {
  notHighlighted: 'not_highlighted',
  renueva: 'renueva',
  subir: 'subir',
  top: 'top',
  urge: 'urge'
}

export const ELECTRIC_CHARGING_TIME_TRACKING_TYPES = {
  [FILTER_NAMES.ELECTRIC_CHARGING_TIME_FAST_MODE]: 'fast',
  [FILTER_NAMES.ELECTRIC_CHARGING_TIME_STANDARD_MODE]: 'standard'
}

export const UTM_TAGS_VALUES = {
  [QUERY_PARAMS.UTM_TAGS.SOURCE]: {
    EMAIL: 'email'
  }
}
